"use client";

import { useEffect, useState } from "react";

import type { PublisherData } from "./buildVideoObjectData";
import { fetchPublisherData } from "./publisherDataAction";

export function usePublisherData(): PublisherData | undefined {
  const [publisher, setPublisher] = useState<PublisherData | undefined>(undefined);

  useEffect(() => {
    fetchPublisherData()
      .then(setPublisher)
      .catch(() => undefined);
  }, []);

  return publisher;
}
